

export const missions = [
    {
        id: "m-1994",
        year: 1994,
        location_en: "La Victoria, Santo Domingo, Dominican Republic",
        location_es: "La Victoria, Santo Domingo, República Dominicana",
        title_en: "First Mission in La Victoria, Santo Domingo",
        title_es: "Primera Mision en la victoria Santo Domingo",
        description_en:
            "In 1994, SODECO was founded in La Victoria, Santo Domingo. During its first mission, the organization delivered medical kits to families affected by urgent needs, marking the beginning of its commitment to God, family, and education.",
        description_es:
            "En 1994 nació SODECO en La Victoria, Santo Domingo. Durante su primera misión, la organización entregó kits médicos a familias afectadas por necesidades urgentes, marcando el inicio de su compromiso con Dios, la familia y la educación. .",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1787025852/3773dc53-57cf-4537-9d8d-182925ff04a9_mbjfie.jpg",
    },
    {
        id: "m-1998",
        year: 1998,
        location_en: "San Francisco de Macorís, Dominican Republic",
        location_es: "San Francisco de Macorís, República Dominicana",
        title_en: "Community Solidarity in San Francisco de Macorís",
        title_es: "Solidaridad comunitaria en San Francisco de Macorís",
        description_en:
            "In 1998, SODECO organized basic medical brigades in rural communities of San Francisco de Macorís, providing primary health care and strengthening solidarity and community development in the region.",
        description_es:
            "En 1998, SODECO organizó brigadas médicas básicas en comunidades rurales de San Francisco de Macorís, ofreciendo atención primaria de salud y fortaleciendo la solidaridad y el desarrollo comunitario en la región.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1782270021/WhatsApp_Image_2026-05-15_at_23.50.11_1_rtt2nh.jpg",
    },
    {
        id: "m-2000",
        year: 2000,
        location_en: "San Cristóbal, Dominican Republic",
        location_es: "San Cristóbal, República Dominicana",
        title_en: "Community Reconstruction in San Cristóbal",
        title_es: "Reconstrucción comunitaria en San Cristóbal",
        description_en:
            "In the year 2000, SODECO supported communities in San Cristóbal through the reconstruction of churches and schools, as well as the distribution of gifts to children, strengthening faith, education, and hope in the region.",
        description_es:
            "En el año 2000, SODECO acompañó a comunidades de San Cristóbal mediante la reconstrucción de iglesias y escuelas, además de la entrega de regalos a niños, fortaleciendo la fe, la educación y la esperanza en la región.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1782270159/WhatsApp_Image_2026-05-15_at_23.50.13_3_hhwuka.jpg",
    },
    {
        id: "m-2005",
        year: 2005,
        location_en: "Monte Plata, Dominican Republic",
        location_es: "Monte Plata, República Dominicana",
        title_en: "Emergency Response: Pediatric Care Centers and Medical Brigades",
        title_es: "Centros de atención pediátrica y brigadas médicas",
        description_en:
            "In 2005, SODECO established pediatric care centers and organized medical brigades in Monte Plata. Additionally, it provided emergency response with hygiene kits, maternal care, and child protection for displaced families, strengthening community health and well-being.",
        description_es:
            "En 2005, SODECO estableció centros de atención pediátrica y organizó brigadas médicas en Monte Plata. Además, brindó respuesta de emergencia con kits de higiene, atención materna y protección infantil para familias desplazadas, fortaleciendo la salud y el bienestar comunitario.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1786583579/e5f756b8-cd73-47ae-9418-ba94c57c3ee8_aksq8k.jpg",
    },
    {
        id: "m-2010",
        year: 2010,
        location_en: "Higüey, La Altagracia, Dominican Republic",
        location_es: "Higüey, La Altagracia, República Dominicana",
        title_en: "Community Support in Higüey",
        title_es: "Apoyo comunitario en Higüey",
        description_en:
            "In 2010, SODECO supported vulnerable communities in Higüey through the reconstruction of churches and schools, as well as the delivery of gifts to children, strengthening faith, education, and hope in the region.",
        description_es:
            "En 2010, SODECO acompañó a comunidades vulnerables de Higüey mediante la reconstrucción de iglesias y escuelas, además de la entrega de regalos a niños, fortaleciendo la fe, la educación y la esperanza en la región",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1786583611/87120d4a-7244-4c68-89a3-69b862fbeeac_o4wbwz.jpg",
    },
    {
        id: "m-2015",
        year: 2015,
        location_en: "Santiago, Dominican Republic",
        location_es: "Santiago, República Dominicana",
        title_en: "Preventive Health in Santiago",
        title_es: "Salud preventiva en Santiago",
        description_en:
            "In 2015, SODECO conducted preventive health campaigns and shelter habilitation in Santiago, providing basic medical care and safe spaces for the most vulnerable families.",
        description_es:
            "En 2015, SODECO llevó a cabo campañas de salud preventiva y habilitación de refugios en Santiago, ofreciendo atención médica básica y espacios seguros para las familias más vulnerables",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1786583670/ba98e303-58a6-464c-93cb-9e1d4e943934_liuhhl.jpg",
    },
    {
        id: "m-2020",
        year: 2020,
        location_en: "Barahona, Dominican Republic",
        location_es: "Barahona, República Dominicana",
        title_en: "Community Response in Barahona",
        title_es: "Respuesta comunitaria en Barahona",
        description_en:
            "In 2020, SODECO deployed mobile clinics, potable water systems, and comprehensive support to rural communities in Barahona, providing assistance after the impact of the earthquake and strengthening local resilience.",
        description_es:
            "En 2020, SODECO desplegó clínicas móviles, sistemas de agua potable y apoyo integral a comunidades rurales de Barahona, brindando asistencia tras el impacto del terremoto y fortaleciendo la resiliencia local.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1786583710/c4836d4b-9bc0-47d9-91f8-62965563a2c0_itskr7.jpg",
    },
    {
        id: "m-2025",
        year: 2025,
        location_en: "Puerto Plata, Dominican Republic",
        location_es: "Puerto Plata, República Dominicana",
        title_en: "Community Resilience in Puerto Plata",
        title_es: "Resiliencia comunitaria en Puerto Plata",
        description_en:
            "Community education programs and health brigades.",
        description_es:
            "En 2025, SODECO desarrolló programas de educación comunitaria y brigadas de salud en Puerto Plata, fortaleciendo la resiliencia climática y el bienestar de las familias locales.",
        image:
            "https://res.cloudinary.com/dv8quznfv/image/upload/v1786584326/af9a3a31-b933-45b2-8fc7-64d8ea359561_joasq0.jpg",
    },
];

export default missions;
